export class ExcelConst
{
    public static EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    public static EXCEL_EXTENSION = '.xlsx';
}